import React from "react";

import DefaultCell from "root/entities/TableCells/Custom/DefaultCell";
import { postfixes, symbols } from "root/utils";
import globalColumns from "root/utils/columns/data";
import { socialNetworksData } from "root/utils/socialNetworks";
import { getBloggerSizeTitle, getSuccessLevelTitle } from "root/utils/socialNetworks/bloggers";

import { numberWithSpaces } from "root/js/utils";

//
const tooltipPS =
  "В расчет данного показателя берутся последние известные посты за выбранный период.";
// ------------------------------------------ ОСНОВА ДЛЯ ОТРИСОВКИ ФИЛЬТРОВ И ТАБЛИЦ
export const bloggersProfilesColumns = [
  {
    dataIndex: "view_avg",
    title: "Просмотров на публикацию",
    tooltip: (
      <>
        <b>Среднее количество просмотров на 1 публикацию с рекламой товаров WB.</b>
        <br />
        {tooltipPS}
      </>
    ),
    default: true,
  },
  {
    dataIndex: "posts_count",
    tooltip: (
      <>
        <b>Количество постов с рекламой товаров WB у блогера.</b>
        <br />
        {tooltipPS}
      </>
    ),
    default: true,
  },
  {
    dataIndex: "er_avg",
    tooltip: globalColumns.er.tooltip,
    default: true,
    render: v => numberWithSpaces(v, 2) + (!isNaN(v) ? postfixes.percent : ""),
  },
  {
    dataIndex: "err_avg",
    tooltip: globalColumns.err.tooltip,
    default: true,
    render: v => numberWithSpaces(v, 2) + (!isNaN(v) ? postfixes.percent : ""),
  },
  {
    dataIndex: "success_level_avg",
    title: "Ср. успешность публикации",
    // title: globalColumns.success_level.title,
    tooltip: globalColumns.success_level.tooltip,
    default: true,
    render: value => getSuccessLevelTitle(value),
    hideFilter: true,
  },
  {
    dataIndex: "subscriber_count",
    default: true,
    render: value => getBloggerSizeTitle(value),
  },
  {
    dataIndex: "w_proceeds_avg",
    tooltip: (
      <>
        <b>Средняя расчетная выручка от публикации за 3 дня после нее.</b>
        <br />
        Показывает реальный вклад публикации в выручку артикула.
        <br />
        {tooltipPS}
      </>
    ),
    postfix: postfixes.rub,
    default: true,
  },
  {
    dataIndex: "reactions_avg",
    tooltip: (
      <>
        <b>
          Среднее количество реакций на публикацию блогера - лайков, комментариев, сохранений и
          репостов.
        </b>
        <br />
        {tooltipPS}
      </>
    ),
    postfix: postfixes.pcs,
    default: true,
  },
  {
    dataIndex: "valueble_posts_percent",
    tooltip: (
      <>
        <b>Процент публикаций с высоким влиянием внешки за 3 дня после публикации</b>
        <br />
        Доля публикаций блогера, у которых расчетная выручка от интеграции больше или равна 15% от
        общего прироста выручки артикула за 3 дня после публикации.
        <br />
        {tooltipPS}
      </>
    ),
    default: true,
  },
  {
    dataIndex: "subject_post_percent",
    title: "Доля публикаций блогера по предметам",
    hint: (
      <>
        <b>Доля публикаций блогера по предметам</b>
        <br />
        Фильтр оставит только тех блогеров, у которых доля публикаций с рекламой товаров из
        выбранных вами предметов находится в рамках выбранного вами диапазона.
        <br />
        {tooltipPS}
      </>
    ),
    postfix: postfixes.percent,
    default: true,
    render: value => <DefaultCell value={value} postfix={postfixes.percent} fontWeight={400} />,
  },
  {
    dataIndex: "w_orders_avg",
    tooltip: (
      <>
        <b>Среднее расчетное количество заказов за 3 дня после публикации.</b>
        <br />
        {tooltipPS}
      </>
    ),
    default: true,
  },
  {
    dataIndex: "comment_avg",
    title: "Ср. кол-во комментариев на публикациях",
    tooltip: (
      <>
        <b>Среднее кол-во комментариев на 1 публикацию с рекламой товаров WB.</b>
        <br />
        {tooltipPS}
      </>
    ),
    postfix: postfixes.pcs,
  },
  {
    dataIndex: "like_avg",
    title: "Ср. кол-во лайков на публикацию",
    tooltip: (
      <>
        <b>Среднее количество лайков на 1 публикацию с рекламой товаров WB.</b>
        <br />
        {tooltipPS}
      </>
    ),
    postfix: postfixes.pcs,
  },
  {
    dataIndex: "share_avg",
    title: "Ср. кол-во репостов на публикациях",
    tooltip: (
      <>
        <b>Среднее количество репостов на 1 публикацию с рекламой товаров WB.</b>
        <br />
        {tooltipPS}
      </>
    ),
    postfix: postfixes.pcs,
    render: value => <DefaultCell value={value} postfix={postfixes.pcs} fontWeight={400} />,
  },
  {
    dataIndex: "valueble_posts_count",
    tooltip: (
      <>
        <b>Количество публикаций с высоким влиянием внешки за 3 дня после публикации</b>
        <br />
        Количество публикаций блогера, у которых расчетная выручка от интеграции больше или равна
        15% от общего прироста выручки артикула за 3 дня после публикации.
        <br />
        {tooltipPS}
      </>
    ),
  },
  {
    dataIndex: "w_price_diff_avg",
    tooltip: (
      <>
        <b>Средний прирост чека за 3 дня после публикации.</b>
        <br />
        {tooltipPS}
      </>
    ),
    postfix: postfixes.rub,
  },
  {
    dataIndex: "orders_percent_avg",
    tooltip: (
      <>
        <b>Средний прирост количества заказов за 3 дня после публикации.</b>
        <br />
        {tooltipPS}
      </>
    ),
  },
  {
    dataIndex: "orders_diff_avg",
    title: "Заказов на публикацию",
    tooltip: (
      <>
        <b>Средний прирост количества заказов за 3 дня после публикации.</b>
        <br />
        {tooltipPS}
      </>
    ),
  },
  {
    dataIndex: "lost_orders_percent_avg",
    title: "Ср. прирост кол-ва упущенных заказов",
    tooltip: (
      <>
        <b>Средний прирост количества упущенных заказов за 3 дня после публикации.</b>
        <br />
        {tooltipPS}
      </>
    ),
    postfix: postfixes.percent,
  },

  {
    dataIndex: "proceeds_percent_avg",
    tooltip: (
      <>
        <b>Средний прирост выручки за 3 дня после публикации.</b>
        <br />
        {tooltipPS}
      </>
    ),
  },
  {
    dataIndex: "proceeds_diff_avg",
    tooltip: (
      <>
        <b>Средний прирост выручки за 3 дня после публикации.</b>
        <br />
        {tooltipPS}
      </>
    ),
  },
  {
    dataIndex: "lost_proceeds_diff_avg",
    title: "Ср. прирост упущенной выручки",
    tooltip: (
      <>
        <b>Средний прирост упущенной выручки за 3 дня после публикации.</b>
        <br />
        {tooltipPS}
      </>
    ),
    postfix: postfixes.percent,
  },
].map(item => {
  const { title, tooltip, postfix } = globalColumns[item.dataIndex] || {};
  return { title, postfix, tooltip, ...item, sortable: true };
});

//
//
//
const getBloggersPostsColumnsById = id =>
  bloggersProfilesColumns.find(item => item.dataIndex === id) || {};
//
const bloggersProfilesParamsForRedux = bloggersProfilesColumns.reduce((acc, item) => {
  ["__gte", "__lte"].forEach(flag => (acc[item.dataIndex + flag] = ""));
  return acc;
}, {});
//  --------------------------- Мутация данных для отправки на сервер
const getDataForServerFromBloggersPostsParams = data => {
  const correctData = {};
  for (const key in data) {
    if (key.includes("lte") || key.includes("gte")) {
      // if (data[key]) correctData[key] = parseInt(data[key].slice(3).replace(/\s/g, ""));
      if (!isFinite(data[key])) continue;
      if (data[key]) correctData[key] = data[key];
    }
    // else if (key === "valueble")
    //   correctData[key] = externalTrafficOptions.find(item => item.id === data[key]).serverValue;
    else if (key.includes("__in")) {
      correctData[key] =
        Array.isArray(data[key]) && data[key].length ? data[key].join() : undefined;
    } else {
      switch (key) {
        case "source":
          correctData[key + "__in"] = data[key].length ? data[key].join() : undefined;
          break;
        case "account_name_hash":
        case "brand_id":
        case "product_id":
        case "subject_id":
          correctData[key + "__in"] = data[key].length
            ? data[key].map(item => item.id).join()
            : undefined;
          break;
      }
      if (typeof data.limited === "boolean") {
        correctData.limited = data.limited;
      }
    }
  }
  // Отдельная логика для работы с блогерами, если не выбраны соцсети, но
  // выбраны блогеры, то надо фильтровать только по соцсетям выбранных блогеров
  if (correctData.account_name_hash__in && !correctData.source__in) {
    correctData.source__in = (data.account_name_hash || [])
      .reduce((acc, item) => {
        const sourceId = socialNetworksData.find(i => i.name === item.source)?.id;
        return sourceId && !acc.includes(sourceId) ? [...acc, sourceId] : acc;
      }, [])
      .join();
  }
  return correctData;
};

export { getDataForServerFromBloggersPostsParams, bloggersProfilesParamsForRedux };
